import { render } from "./ProductComplianceAccordion.vue?vue&type=template&id=0030d8d1"
import script from "./ProductComplianceAccordion.vue?vue&type=script&lang=js"
export * from "./ProductComplianceAccordion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__